/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacyImplantStocks } from 'app/entities/pharmacy-implant-stock/pharmacy-implant-stock.reducer';
import { getEntities as getPharmacyReturnBills } from 'app/entities/pharmacy-return-bill/pharmacy-return-bill.reducer';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-implant-return-bill-item.reducer';

export const PharmacyImplantReturnBillItemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacyImplantStocks = useAppSelector(state => state.pharmacyImplantStock.entities);
  const pharmacyReturnBills = useAppSelector(state => state.pharmacyReturnBill.entities);
  const pharmacyImplantReturnBillItemEntity = useAppSelector(state => state.pharmacyImplantReturnBillItem.entity);
  const loading = useAppSelector(state => state.pharmacyImplantReturnBillItem.loading);
  const updating = useAppSelector(state => state.pharmacyImplantReturnBillItem.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyImplantReturnBillItem.updateSuccess);

  const handleClose = () => {
    navigate(`/pharmacy-implant-return-bill-item${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacyImplantStocks({}));
    dispatch(getPharmacyReturnBills({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.chargedMrp !== undefined && typeof values.chargedMrp !== 'number') {
      values.chargedMrp = Number(values.chargedMrp);
    }
    if (values.returnClaimed !== undefined && typeof values.returnClaimed !== 'number') {
      values.returnClaimed = Number(values.returnClaimed);
    }
    if (values.returnQty !== undefined && typeof values.returnQty !== 'number') {
      values.returnQty = Number(values.returnQty);
    }
    if (values.manufacDate !== undefined && typeof values.manufacDate !== 'number') {
      values.manufacDate = Number(values.manufacDate);
    }
    if (values.expDate !== undefined && typeof values.expDate !== 'number') {
      values.expDate = Number(values.expDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }

    const entity = {
      ...pharmacyImplantReturnBillItemEntity,
      ...values,
      pharmacyStock: pharmacyImplantStocks.find(it => it.id.toString() === values.pharmacyStock?.toString()),
      returnBill: pharmacyReturnBills.find(it => it.id.toString() === values.returnBill?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...pharmacyImplantReturnBillItemEntity,
          pharmacyStock: pharmacyImplantReturnBillItemEntity?.pharmacyStock?.id,
          returnBill: pharmacyImplantReturnBillItemEntity?.returnBill?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.pharmacyImplantReturnBillItem.home.createOrEditLabel"
            data-cy="PharmacyImplantReturnBillItemCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.pharmacyImplantReturnBillItem.home.createOrEditLabel">
              Create or edit a PharmacyImplantReturnBillItem
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-implant-return-bill-item-id"
                  label={translate('tinyMedicRestApp.pharmacyImplantReturnBillItem.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantReturnBillItem.chargedMrp')}
                id="pharmacy-implant-return-bill-item-chargedMrp"
                name="chargedMrp"
                data-cy="chargedMrp"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantReturnBillItem.returnClaimed')}
                id="pharmacy-implant-return-bill-item-returnClaimed"
                name="returnClaimed"
                data-cy="returnClaimed"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantReturnBillItem.returnQty')}
                id="pharmacy-implant-return-bill-item-returnQty"
                name="returnQty"
                data-cy="returnQty"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantReturnBillItem.manufacDate')}
                id="pharmacy-implant-return-bill-item-manufacDate"
                name="manufacDate"
                data-cy="manufacDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantReturnBillItem.expDate')}
                id="pharmacy-implant-return-bill-item-expDate"
                name="expDate"
                data-cy="expDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantReturnBillItem.active')}
                id="pharmacy-implant-return-bill-item-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantReturnBillItem.cursor')}
                id="pharmacy-implant-return-bill-item-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantReturnBillItem.timestampEntry')}
                id="pharmacy-implant-return-bill-item-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantReturnBillItem.microSec')}
                id="pharmacy-implant-return-bill-item-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantReturnBillItem.lastUpdated')}
                id="pharmacy-implant-return-bill-item-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="pharmacy-implant-return-bill-item-pharmacyStock"
                name="pharmacyStock"
                data-cy="pharmacyStock"
                label={translate('tinyMedicRestApp.pharmacyImplantReturnBillItem.pharmacyStock')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyImplantStocks
                  ? pharmacyImplantStocks.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-implant-return-bill-item-returnBill"
                name="returnBill"
                data-cy="returnBill"
                label={translate('tinyMedicRestApp.pharmacyImplantReturnBillItem.returnBill')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyReturnBills
                  ? pharmacyReturnBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/pharmacy-implant-return-bill-item"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyImplantReturnBillItemUpdate;
